import { render } from "./hand-8.vue?vue&type=template&id=ceb09eba&scoped=true"
import script from "./hand-8.vue?vue&type=script&lang=js"
export * from "./hand-8.vue?vue&type=script&lang=js"

import "./hand-8.vue?vue&type=style&index=0&id=ceb09eba&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb09eba"]])

export default __exports__